
    import './styles.scoped.css';
    export default {
  "dropdown-content-wrapper": "awsui_dropdown-content-wrapper_qwoo0_1yx3j_97",
  "awsui-motion-fade-in-dropdown": "awsui_awsui-motion-fade-in-dropdown_qwoo0_1yx3j_1",
  "refresh": "awsui_refresh_qwoo0_1yx3j_118",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_qwoo0_1yx3j_1",
  "root": "awsui_root_qwoo0_1yx3j_147",
  "interior": "awsui_interior_qwoo0_1yx3j_183",
  "dropdown": "awsui_dropdown_qwoo0_1yx3j_97",
  "use-portal": "awsui_use-portal_qwoo0_1yx3j_194",
  "is-empty": "awsui_is-empty_qwoo0_1yx3j_240",
  "dropdown-drop-up": "awsui_dropdown-drop-up_qwoo0_1yx3j_247",
  "with-limited-width": "awsui_with-limited-width_qwoo0_1yx3j_251",
  "dropdown-drop-left": "awsui_dropdown-drop-left_qwoo0_1yx3j_254",
  "dropdown-drop-right": "awsui_dropdown-drop-right_qwoo0_1yx3j_261",
  "occupy-entire-width": "awsui_occupy-entire-width_qwoo0_1yx3j_268",
  "stretch-beyond-trigger-width": "awsui_stretch-beyond-trigger-width_qwoo0_1yx3j_271",
  "hide-block-border": "awsui_hide-block-border_qwoo0_1yx3j_278",
  "open": "awsui_open_qwoo0_1yx3j_287",
  "nowrap": "awsui_nowrap_qwoo0_1yx3j_296",
  "dropdown-content": "awsui_dropdown-content_qwoo0_1yx3j_97",
  "stretch-trigger-height": "awsui_stretch-trigger-height_qwoo0_1yx3j_307"
};
  